module.exports = __webpack_public_path__ + "img/normal-visual.d50e3ba9.webp";